import React from 'react';
import { SsoDataContext } from './context';
import CoreClient from '@c42/core-client';
import { useRoutingData } from '../routing/hooks';
import { DEFAULT_REDIRECT_AFTER_LOGIN } from '../../../constants/routes';
import { MATCH_ALL_BACKSLASHES } from '../../../constants/regexes';

export const AUTHORITY_IDENTITY_PROVIDERS_PATH = '/api/v1/SsoLoginIdentityProvider';
export const AUTHORITY_SSO_AUTH_LOGIN_PATH = '/api/v1/SsoAuthLogin';

export const useSsoData = () => React.useContext(SsoDataContext).ssoData;

export const useSetSsoData = () => React.useContext(SsoDataContext).setSsoData;

export const useFetchIdentityProviders = () => {
  const setSsoData = useSetSsoData();

  return ({ registrationKey, username }: { registrationKey: string; username: string }) => {
    setSsoData((current) => ({
      ...current,
      isFetchingIdps: true,
      ssoError: null,
    }));

    const query = { username, registrationKey };
    const findParams = {
      query,
      options: {
        url: AUTHORITY_IDENTITY_PROVIDERS_PATH,
      },
    };

    return CoreClient.SsoIdentityProvider.find(findParams).then(
      (data) => {
        const identityProviders = data || [];
        setSsoData((current) => ({
          ...current,
          isFetchingIdps: false,
          identityProviders,
        }));
      },
      () => {
        setSsoData((current) => ({
          ...current,
          isFetchingIdps: false,
          ssoError: 'sso_load_idps_error',
        }));
      },
    );
  };
};

export const useOnSubmitSso = () => {
  const routingData = useRoutingData();

  const getSsoAuthRedirectUrl = (): string => {
    let redirectPath =
      !routingData.redirectParam || routingData.redirectParam.indexOf('/login') === 0
        ? DEFAULT_REDIRECT_AFTER_LOGIN
        : routingData.redirectParam;

    // Remove any potential backslashes from the redirectPath (PL-105140)
    redirectPath = redirectPath.replace(MATCH_ALL_BACKSLASHES, '');

    return `/login/#/login?to=${encodeURIComponent(redirectPath)}`;
  };

  return (ssoIdentityProviderUid: string) => {
    const ssoAuthRedirectUrl = getSsoAuthRedirectUrl();
    window.location.assign(
      `${AUTHORITY_SSO_AUTH_LOGIN_PATH}?identityProviderUid=${ssoIdentityProviderUid}&redirectUrl=${encodeURIComponent(
        ssoAuthRedirectUrl,
      )}`,
    );
  };
};
